import { Grid, MenuItem, Paper, TextField } from '@mui/material';

import { MONTH_OPTIONS } from '../../constants/puntajeConstants';
import { getGroupLabel } from '../../utils/puntajeFormatters';

const PuntajeFilters = ({
  groups,
  loadingGroups,
  selectedGroupUuid,
  year,
  month,
  onSelectGroup,
  onYearChange,
  onMonthChange,
}) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextField
          select
          fullWidth
          label="Grupo"
          value={selectedGroupUuid}
          onChange={(event) => onSelectGroup(event.target.value)}
          disabled={loadingGroups}
        >
          {groups.map((group) => (
            <MenuItem key={group.uuid} value={group.uuid}>
              {getGroupLabel(group)}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          type="number"
          label="Año"
          value={year}
          onChange={(event) => onYearChange(Number(event.target.value))}
          inputProps={{ min: 2026, max: 2100 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          select
          fullWidth
          label="Mes"
          value={month}
          onChange={(event) => onMonthChange(Number(event.target.value))}
        >
          {MONTH_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

    </Grid>
  </Paper>
);

export default PuntajeFilters;
